import {isNil} from 'ramda';

import type {
  FinancingEndingBulkOperationItemResponseBody,
  FinancingEndingBulkOperationItemWire,
  FinancingEndingBulkOperationResponseBody,
  FinancingEndingBulkOperationWire,
} from '../types';

export const mapFinancingEndingBulkOperation = ({
  outcomeCounts,
  detail,
  ...operation
}: FinancingEndingBulkOperationWire): FinancingEndingBulkOperationResponseBody => ({
  ...operation,
  templateName: detail?.templateName ?? null,
  mailbox: detail?.mailbox ?? null,
  sentBy: detail?.sentBy ?? null,
  emailOutcomeCounts: isNil(outcomeCounts)
    ? null
    : {
        sent: outcomeCounts.SENT,
        failed: outcomeCounts.FAILED,
        blocked: outcomeCounts.BLOCKED,
        pending: outcomeCounts.PENDING,
      },
});

export const mapFinancingEndingBulkOperationItem = ({
  outcome,
  detail,
  ...item
}: FinancingEndingBulkOperationItemWire): FinancingEndingBulkOperationItemResponseBody => ({
  ...item,
  emailOutcome: outcome ?? null,
  recipientName: detail?.recipientName ?? null,
  recipientEmail: detail?.recipientEmail ?? null,
  sentMessageId: detail?.sentMessageId ?? null,
});
